<template>
  <div>
    <onboarding-wizard-heading
      class="mb-8"
      :title="$t('pages.onBoarding.step04.whatIsTheName')"
      :description="$t('pages.onBoarding.step04.ifYouHaveNotDecidedYet')"
      :show-tick-mark="localData.ideaName !== ''"
      text-center
      top-space="0"
    />

    <v-row dense class="mb-2">
      <v-col :cols="12" :md="5" class="mb-3 mb-md-0">
        <onboarding-wizard-idea-cover
          :cover="categoryCover"
          :icon="categoryIcon"
          @update:cover="localData.croppedImage = $event"
        />
      </v-col>

      <v-col :cols="12" :md="7">
        <v-text-field
          v-model="localData.ideaName"
          class="mb-2"
          :label="$t('pages.onBoarding.step04.ideaName')"
          outlined
          hide-details
          :disabled="loading"
          :loading="loading"
          dense
          background-color="#FAFBFF"
          height="46px"
        >
          <template v-if="isUseAi" #append-outer>
            <ib-tooltip popper-class="plan-popper">
              <div slot="content" class="tooltip-content">
                <p>{{ $t('generateIdeas') }}</p>
              </div>
              <ai-buddy-button-rounded class="button-vertical-align" :animation="animationBtn" @click="fetchSuggestions" />
            </ib-tooltip>
          </template>
        </v-text-field>

        <onboarding-suggestions
          :suggestions="suggestions"
          @click="localData.ideaName = $event"
        />

        <v-textarea
          v-model="localData.ideaSlogan"
          :label="$t('pages.onBoarding.step04.yourSlogan')"
          outlined
          hide-details
          background-color="#FAFBFF"
          rows="2"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AiBuddyButtonRounded from '@/views/Home/StoryMode/Components/AiBuddyButtonRounded.vue'
import OnboardingSuggestions from '@/views/Onboarding/Components/OnboardingSuggestions.vue'
import OnboardingWizardHeading from '@/views/Onboarding/Components/OnboardingWizard/OnboardingWizardHeading.vue'
import OnboardingWizardIdeaCover from '@/views/Onboarding/Components/OnboardingWizard/OnboardingWizardIdeaCover.vue'
import _find from 'lodash/find'

export default {
  name: 'OnboardingFourthStep',

  components: { AiBuddyButtonRounded, OnboardingSuggestions, OnboardingWizardHeading, OnboardingWizardIdeaCover },

  inject: ['selectedCategory', 'getCountries', 'getIsUseAi'],

  props: {
    data: {
      type: Object,
      default: () => {
        return {
          ideaName: '',
          ideaSlogan: '',
          croppedImage: null
        }
      }
    }
  },

  data () {
    return {
      localData: {
        ideaName: '',
        ideaSlogan: '',
        croppedImage: null
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      suggestions: [],
      loading: false,
      animationBtn: true
    }
  },

  computed: {
    category () {
      return this.selectedCategory()
    },

    categoryCover () {
      if (!this.category) return ''

      return `${this.baseUrl}${this.category.cover.sizes.original}`
    },

    categoryIcon () {
      if (!this.category) return ''

      return `${this.baseUrl}${this.category.icon.sizes.original}`
    },

    countries () {
      return this.getCountries()
    },

    country () {
      const country = _find(this.countries, ['code', this.localData.country])
      if (!country) return ''

      return country.name
    },

    isUseAi () {
      return this.getIsUseAi()
    }
  },

  created () {
    this.localData = this.data
  },

  methods: {
    async fetchSuggestions () {
      this.animationBtn = false
      this.suggestions = []
      try {
        this.loading = true
        const response = await this.$http.post('ai/idea-name-suggestions', {
          description: this.localData.description,
          country: this.country,
          city: this.localData.city
        })

        this.suggestions = response.data.payload.data

        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">

.button-vertical-align {
  margin-top: -8px;
}

</style>
